document.addEventListener('DOMContentLoaded', function() {

    // Frontpage slider scroll past function
    var btn = document.getElementById('scroll-past-slideshow');
    if (btn) {
        btn.addEventListener('click', function() {
            var slideshow = document.querySelector('.slideshow-section');
            var header = document.querySelector('header');
            if (slideshow) {
                var rect = slideshow.getBoundingClientRect();
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                var headerHeight = header ? header.offsetHeight : 0;
                window.scrollTo({
                    top: rect.bottom + scrollTop - headerHeight,
                    behavior: 'smooth'
                });
            }
        });
    }


  // Custom dropdown options functionality
  const dropdown = document.getElementById('CustomSortDropdown');
  if (dropdown) {
    const optionsList = dropdown.querySelector('.custom-dropdown__options');
    const selected = dropdown.querySelector('.custom-dropdown__selected');
    const options = dropdown.querySelectorAll('.custom-dropdown__option');

    // Toggle dropdown
    dropdown.addEventListener('click', function (e) {
      e.stopPropagation();
      const expanded = dropdown.getAttribute('aria-expanded') === 'true';
      dropdown.setAttribute('aria-expanded', !expanded);
      optionsList.style.display = expanded ? 'none' : 'block';
    });

    // Select option
    options.forEach(option => {
      option.addEventListener('click', function (e) {
        e.stopPropagation();
        selected.textContent = option.textContent;
        options.forEach(opt => opt.classList.remove('selected'));
        option.classList.add('selected');
        optionsList.style.display = 'none';
        dropdown.setAttribute('aria-expanded', 'false');
        // Optionally, trigger sorting here:
        window.location.search = updateQueryStringParameter(window.location.search, 'sort_by', option.dataset.value);
      });
    });

    // Close dropdown on outside click
    document.addEventListener('click', function () {
      optionsList.style.display = 'none';
      dropdown.setAttribute('aria-expanded', 'false');
    });

    // Keyboard navigation
    dropdown.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        let idx = Array.from(options).findIndex(opt => opt.classList.contains('selected'));
        if (e.key === 'ArrowDown') idx = (idx + 1) % options.length;
        if (e.key === 'ArrowUp') idx = (idx - 1 + options.length) % options.length;
        options.forEach(opt => opt.classList.remove('selected'));
        options[idx].classList.add('selected');
        selected.textContent = options[idx].textContent;
      }
      if (e.key === 'Enter' || e.key === ' ') {
        dropdown.click();
      }
      if (e.key === 'Escape') {
        optionsList.style.display = 'none';
        dropdown.setAttribute('aria-expanded', 'false');
      }
    });
  }

    // Helper to update query string
    function updateQueryStringParameter(uri, key, value) {
        var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        var separator = uri.indexOf('?') !== -1 ? '&' : '?';
        if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + value + '$2');
        } else {
        return uri + separator + key + '=' + value;
        }
    }

  var modalOpeners = document.querySelectorAll('div[role="button"][data-modal]');
  modalOpeners.forEach(function (el) {
    el.addEventListener('click', function () {
      var modalId = el.getAttribute('data-modal');
      var modal = document.getElementById(modalId);
      if (modal) {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
      }
    });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        el.click();
      }
    });
  });


  // Close modal when clicking the close button
  document.querySelectorAll('.schiang-modal__close').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var modal = btn.closest('.schiang-modal');
      if (modal) {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
      }
      e.stopPropagation();
    });
  });

  // Close modal when clicking outside modal content
  document.querySelectorAll('.schiang-modal').forEach(function (modal) {
    modal.addEventListener('mousedown', function (e) {
      // Only close if clicking directly on the modal overlay, not the content
      if (e.target === modal) {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
      }
    });
  });


  // Check if the event is from the variant picker
  /* if (e.target.closest('form') && e.target.name === 'id') {
    const variantId = parseInt(e.target.value, 10);
    const variant = variants.find(v => v.id === variantId);
    if (variant && variant.metafields && variant.metafields.custom && variant.metafields.custom.leveringstid) {
      console.log('Leveringstid:', variant.metafields.custom.leveringstid);
    } else {
      console.log('No leveringstid metafield for this variant');
    }
  } */


  // Collect all brands in same section on brands page
  /* let brandSections = document.querySelectorAll('.brands-page .brands__items-wrapper');
  if (brandSections.length > 0) {
    let allBrands = [];
    brandSections.forEach(section => {
      let brands = section.querySelectorAll('.brands__item');
      brands.forEach(brand => {
        allBrands.push(brand);
      });
    });
    // Move all brands into the first wrapper
    const firstWrapper = brandSections[0];
    allBrands.forEach(brand => {
      firstWrapper.appendChild(brand);
    });
    // Hide all other wrappers
    for (let i = 1; i < brandSections.length; i++) {
      brandSections[i].style.display = 'none';
    }
  } */

    let outerProductsContainer = document.querySelector('.drawer__outer-products');
    let productsReady = false;
    if (outerProductsContainer) {
        let productSections = document.querySelector('product-recommendations.complementary-products.product-recommendations');
        if (productSections) {
            // Function to copy content from productSections into the new container
            function copyProductSectionsContent(source, outerContainer) {
              const titleWrapper = outerContainer.querySelector('.title-wrapper');
              const innerProducts = outerContainer.querySelector('.drawer__inner-products');
              if (!titleWrapper || !innerProducts) return;

              // Move heading
              const heading = source.querySelector('.product-recommendations__heading');
              if (heading && !titleWrapper.querySelector('.product-recommendations__heading')) {
                titleWrapper.appendChild(heading.cloneNode(true));
              }

              // Move product cards, each wrapped in .collection-product-card
              const cards = source.querySelectorAll('.card-wrapper');
              cards.forEach((card, idx) => {
                // Check if already added by product id
                const productId = card.getAttribute('data-product-id') || card.getAttribute('data-product');
                if (!innerProducts.querySelector(`.collection-product-card[data-product-id="${productId}"]`)) {
                  const wrapper = document.createElement('div');
                  wrapper.className = 'collection-product-card';
                  if (productId) wrapper.setAttribute('data-product-id', productId);
                  wrapper.appendChild(card.cloneNode(true));
                  innerProducts.appendChild(wrapper);
                }
              });
            }
            // Run as interval until content is moved
            let moveInterval = setInterval(() => {
                if (outerProductsContainer && productSections) {
                  copyProductSectionsContent(productSections, outerProductsContainer);
                  // Stop interval if heading and at least one card are present
                  if (
                    outerProductsContainer.querySelector('.title-wrapper .product-recommendations__heading') &&
                    outerProductsContainer.querySelector('.drawer__inner-products .card-wrapper')
                  ) {
                    clearInterval(moveInterval);
                    productsReady = true;
                    console.log('Product recommendations moved to drawer');
                  }
                }
            }, 500);
          console.log('Found product recommendation sections:', productSections);

        }
    }

    // Listen for open cart drawer event to trigger product move if not already done
    window.addEventListener('cart-drawer:opened', () => {
      console.log('Cart drawer opened');
      if (productsReady) {
        console.log('Products already moved, just activating drawer');
        let productSections = document.querySelector('.drawer__outer-products');
        productSections.classList.add('active');
        setTimeout(() => {
          productSections.style.zIndex = '100000';
        }, 600);
      }
    });
    window.addEventListener('cart-drawer:closed', () => {
      console.log('Cart drawer closed');
      if (productsReady) {
        console.log('Products already moved, just deactivating drawer');
        let productSections = document.querySelector('.drawer__outer-products');
        productSections.style.zIndex = '1000';
        productSections.classList.remove('active');
      }
    });

});